/**
 * Query Key Factory の単一情報源。
 *
 * 規約:
 * 1. useQuery に配列リテラルを直書きせず、必ずここを経由する
 * 2. key の要素はプレーン JSON 値のみ（関数・クラス・Date は禁止）
 * 3. 階層は [domain, subresource, ...params]。一括 invalidate 用に _root() を必ず用意する
 */

export type PermissionRequests = Readonly<Record<string, readonly string[]>>;

/** JSON 化できる key パラメータ。 */
export type QueryKeyParams = Readonly<
  Record<
    string,
    string | number | boolean | null | undefined | readonly string[]
  >
>;

export const qk = {
  auth: {
    _root: () => ["auth"] as const,
    permissions: (requests: PermissionRequests) =>
      ["auth", "permissions", requests] as const,
    userGroups: () => ["auth", "user-groups"] as const,
  },
  processInstances: {
    _root: () => ["process-instances"] as const,
    forMe: (params: QueryKeyParams) =>
      ["process-instances", "for-me", params] as const,
    all: (params: QueryKeyParams) =>
      ["process-instances", "all", params] as const,
    modelId: (processInstanceId: number) =>
      ["process-instances", "model-id", processInstanceId] as const,
    detail: (modifiedProcessModelId: string, processInstanceId: number) =>
      [
        "process-instances",
        "detail",
        modifiedProcessModelId,
        processInstanceId,
      ] as const,
  },
  processModels: {
    _root: () => ["process-models"] as const,
    runnableList: () => ["process-models", "runnable"] as const,
    designList: () => ["process-models", "design-list"] as const,
  },
  processGroups: {
    _root: () => ["process-groups"] as const,
    list: () => ["process-groups", "list"] as const,
  },
  tasks: {
    _root: () => ["tasks"] as const,
    forMe: (params: QueryKeyParams) => ["tasks", "for-me", params] as const,
    forProcessInstance: (processInstanceId: number) =>
      ["tasks", "for-process-instance", processInstanceId] as const,
    form: (processInstanceId: number, taskGuid: string) =>
      ["tasks", "form", processInstanceId, taskGuid] as const,
  },
} as const;
